/**
 * Mapping from tonal.js intervals to musical alterations
 */
export const INTERVAL_TO_ALTERATION: Record<string, string> = {
  // Flat alterations
  '1d': 'b', // diminished unison
  '2m': 'b', // minor second
  '3m': 'b', // minor third
  '4d': 'b', // diminished fourth
  '5d': 'b', // diminished fifth
  '6m': 'b', // minor sixth
  '7m': 'b', // minor seventh
  '8d': 'b', // diminished octave

  // Double flat alterations
  '1dd': 'bb', // double diminished unison
  '2d': 'bb', // diminished second
  '3d': 'bb', // diminished third
  '4dd': 'bb', // double diminished fourth
  '5dd': 'bb', // double diminished fifth
  '6d': 'bb', // diminished sixth
  '7d': 'bb', // diminished seventh

  // Sharp alterations
  '1A': '#', // augmented unison
  '2A': '#', // augmented second
  '3A': '#', // augmented third
  '4A': '#', // augmented fourth
  '5A': '#', // augmented fifth
  '6A': '#', // augmented sixth
  '7A': '#', // augmented seventh

  // Double sharp alterations
  '1AA': '##', // double augmented unison
  '2AA': '##', // double augmented second
  '3AA': '##', // double augmented third
  '4AA': '##', // double augmented fourth
  '5AA': '##', // double augmented fifth
  '6AA': '##', // double augmented sixth
  '7AA': '##', // double augmented seventh
};
